import { create } from 'zustand';

interface CartAnimation {
  id: string;
  productName: string;
  productImage?: string;
  startX: number;
  startY: number;
  timestamp: number;
}

interface CartAnimationState {
  animations: CartAnimation[];
  triggerAnimation: (product: {
    productName: string;
    productImage?: string;
    startX: number;
    startY: number;
  }) => void;
  removeAnimation: (id: string) => void;
}

export const useCartAnimation = create<CartAnimationState>((set) => ({
  animations: [],
  
  triggerAnimation: (product) => {
    const id = `${Date.now()}-${Math.random()}`;
    const animation: CartAnimation = {
      id,
      productName: product.productName,
      productImage: product.productImage,
      startX: product.startX,
      startY: product.startY,
      timestamp: Date.now(),
    };
    
    set((state) => ({
      animations: [...state.animations, animation],
    }));
    
    // Auto-remove after animation completes
    setTimeout(() => {
      set((state) => ({
        animations: state.animations.filter(a => a.id !== id),
      }));
    }, 1500);
  },
  
  removeAnimation: (id) => {
    set((state) => ({
      animations: state.animations.filter(a => a.id !== id),
    }));
  },
}));
